(function ($) {
	$('.mobileMenu > li > a').on('click', function (e) {
		e.preventDefault();

		var $this = $(this);

		if ($this.hasClass('active')) {
			$this.removeClass('active');
			$this.next().slideUp(350);

			return;
		}

		$this.toggleClass('active');
		$this.next().slideToggle(350);
	});
})(jQuery);
